import React from "react";
import { Navigate, useNavigate } from "react-router-dom";

const AuthRoute = ({ children }) => {
  const token = localStorage.getItem("access_token");

  if (token) {
    return children;
  } else {
    return <Navigate to="/login" replace />;
  }
};

const performLogout = () => {
  localStorage.removeItem("access_token");
};

const getAuthHeader = () => {
  const token = localStorage.getItem("access_token");
  return `Bearer ${token}`;
};

export default AuthRoute;
export { performLogout, getAuthHeader };
